import { AxiosError, AxiosResponse } from 'axios'
import { getInstance } from './instance'
import { WithRecordResponse, WithResponse } from '../models/Response'
import {
  CreatedPostbackInfo,
  EditPostback,
  PostbackCreationInfo,
  PostbackPartner,
} from '../models/Postback'

export const getMeasurementPartners = async () => {
  try {
    const response: AxiosResponse<WithRecordResponse<PostbackPartner[]>> =
      await getInstance().get('/v3/conversion/static/postback/partner-type')
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const createPostbackConversion = async (
  postbackInfo: PostbackCreationInfo
) => {
  try {
    const response: AxiosResponse<WithRecordResponse<CreatedPostbackInfo>> =
      await getInstance().post('/v3/conversion/postback/add', postbackInfo)
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const editPostbackConversion = async (postbackInfo: EditPostback) => {
  try {
    const response: AxiosResponse<WithResponse<EditPostback>> =
      await getInstance().patch('/v3/conversion/postback/update', postbackInfo)
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}
